import { render, staticRenderFns } from "./OrderShowData.vue?vue&type=template&id=5add8522&"
import script from "./OrderShowData.vue?vue&type=script&lang=js&"
export * from "./OrderShowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports